// Función helper para verificar si el país es República Dominicana
export const isDominicanRepublic = (countryIsoCode: string | null | undefined): boolean => {
  if (!countryIsoCode) return false;
  const countryUpper = countryIsoCode.toUpperCase().trim();
  return countryUpper === "DO";
};

// Función para obtener el código del país basado en códigos ISO
// DO = República Dominicana
// AR = Argentina
export const getCountryCode = (countryIsoCode: string | null | undefined): string => {
  if (!countryIsoCode) {
    return "default";
  }
  const countryUpper = countryIsoCode.toUpperCase().trim();
  
  // República Dominicana
  if (countryUpper === "DO") {
    return "DO";
  }
  
  // Argentina
  if (countryUpper === "AR") {
    return "AR";
  }
  
  return "default";
};

